import { Notification } from 'element-ui'

const showNotification = function (type, title, message) {
  const defaultOption = {
    position: 'top-right'
  }

  const option = Object.assign({}, defaultOption, { title, message })
  const notifyFunction = Notification[type]

  if (typeof notifyFunction === 'function') {
    notifyFunction(option)
  }
}

export default {
  methods: {
    // showNotification: show,
    showNotificationSuccess: (title, message) => showNotification('success', title, message),
    showNotificationError: (title, message) => showNotification('error', title, message),
    showNotificationInfo: (title, message) => showNotification('info', title, message),
    showNotificationWarning: (title, message) => showNotification('warning', title, message)
  }
}
